import type { ReactElement } from 'react';

import { createPadding } from '../ui-utils';

import type { ICardContentProps } from './card.interface';

export const CardContent = ({
  children,
  pt = 8,
  pb = 8,
  pl = 8,
  pr = 8,
  className = ''
}: ICardContentProps): ReactElement => {
  return (
    <div
      className={`co-flex-1 co-w-full ${createPadding({ pl, pb, pr, pt })} ${className}`}
    >
      {children}
    </div>
  );
};
